import Vue, { VueConstructor } from 'vue'

declare global {
   interface Array<T> {
      first: T
      last: T
      unique: T[]
      containsSameElementsAs(other: T[]): boolean
      remove(item: T): T[]
   }
}

const extensions = {
   install(vue: VueConstructor) {
      Object.defineProperty(Array.prototype, 'first', {
         get() {
            return this.length > 0 ? this[0] : null
         },
      })

      Object.defineProperty(Array.prototype, 'last', {
         get() {
            return this.length > 0 ? this[this.length - 1] : null
         },
      })

      Object.defineProperty(Array.prototype, 'unique', {
         get() {
            return this.filter((item: any, idx: number, list: any[]) => list.indexOf(item) === idx)
         },
      })

      Object.defineProperty(Array.prototype, 'containsSameElementsAs', {
         value(other: any[]) {
            if (!this || !other) {
               return false
            }
            const aString = this.unique.sort((a: any, b: any) => a.localeCompare(b)).join(',')
            const bString = other.unique.sort((a, b) => a.localeCompare(b)).join(',')
            return aString === bString
         },
      })

      Object.defineProperty(Array.prototype, 'remove', {
         value(item: any) {
            const idx = this.indexOf(item)
            if (idx === -1) {
               return this
            }
            return this.splice(idx, 1)
         },
      })
   },
}

export default extensions
